// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"508":"fb3a724e","883":"bc4b8db1"}[chunkId] + ".chunk.css";
};